module.exports = __webpack_public_path__ + "img/paid.5be0afda.png";